import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

interface TopLoaderProps {
  loading: boolean;
  text?: string;
}

/**
 * 页面级首屏加载提示 — 内容上方一行,简洁不闪烁。
 * 用法:`<TopLoader loading={query.isLoading} text="加载渠道列表..." />`
 *
 * 不替代局部 spinner;仅给"页面 mount 后第一次拿数据"的空白态一个友好提示。
 */
export function TopLoader({ loading, text }: TopLoaderProps) {
  const { t } = useTranslation();
  if (!loading) return null;
  const display = text ?? t("loaders.loading");
  return (
    <div className="fx-enter flex items-center gap-2 text-sm text-muted-foreground py-3">
      <Loader2 className="h-4 w-4 animate-spin" />
      <span className="fx-glow rounded px-1">{display}</span>
    </div>
  );
}
